import {cs} from "../../../../../../react/chain-services";
import {UseState} from "../../../../../../react/use-state";

export const SectionGroup = ({sections, next}) => cs(
    ["showErrors", (_, next) => UseState({next})],
    ["submitting", (_, next) => UseState({next})],
    ({showErrors, submitting}) => next({
        showErrors: showErrors.value,
        invalid: sections.find((s) => s.invalid),
        submitDisabled: !!submitting.value,
        submit: async (onSubmit) => {
            if (sections.find((s) => s.invalid)) {
                showErrors.onChange(true);
                sections.find((s) => s.invalid && s.highlightErrors)?.highlightErrors();
            } else {
                submitting.onChange(true);
                await onSubmit();
                submitting.onChange(false);
            }
        }
    })
);
